import { Box, Typography, Paper, Button } from "@mui/material";
import React, { useState } from "react";
import TagIcon from "@mui/icons-material/Tag";

import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import Divider from "@mui/material/Divider";
import Tooltip from "@mui/material/Tooltip";

const ToolTipContent = (
  <Box sx={{ p: 2 }}>
    <Typography>Top 40%</Typography>
    <Typography>Rarity:3,597/9,999</Typography>
    <Divider />
    <Typography>By OpenRarity</Typography>
  </Box>
);

const ImageCard = ({ image, price, rank, eth, lastSale }) => {
  const [isHovered, setIsHovered] = useState(false);
  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  const componentStyle = {
    display: isHovered ? "block" : "none",
  };
  const HideStyle = {
    display: isHovered ? "none" : "block",
  };

  return (
    <Paper
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      sx={{
        bgcolor: "white",
        minWidth: "350px",
        borderRadius: "7px 7px 12px 12px",
        m: 2,
      }}
    >
      <Box sx={{ display: "flex", justifyContent: "center" }}>
        <img src={image} width='80%' height='60%' />
      </Box>

      <Box
        sx={{
          display: "flex",
          py: 2,
          px: 2,
          justifyContent: "space-between",
        }}
      >
        <Typography sx={{ fontWeight: "bold" }}>
          Milady <span>{price} </span>
        </Typography>

        <Tooltip title={ToolTipContent} arrow placement='top'>
          <Box
            sx={{
              border: "0.2px solid gray",
              px: 1,
              fontWeight: "bold",
              color: "black",
              borderRadius: "5px",
              fontSize: 16,
            }}
          >
            <TagIcon sx={{ fontSize: 15 }} />
            {rank}
          </Box>
        </Tooltip>
      </Box>
      <Box sx={{ display: "flex", px: 2, fontWeight: "bold" }}>
        <Typography sx={{ fontWeight: "bold" }}>
          {eth} <span>ETH</span>
        </Typography>
      </Box>
      <Box sx={{ display: "flex", px: 2, pt: 1, pb: 2 }}>
        <Typography style={HideStyle} sx={{ color: "gray", fontSize: "14px" }}>
          Last Sales:{lastSale} ETH
        </Typography>
      </Box>
      <Box
        style={componentStyle}
        sx={{
          mt: -3,
          display: "flex",
        }}
      >
        <Button
          variant='contained'
          sx={{
            px: 2,
            width: "100%",
            borderRadius: "0 0 12px 12px",
            display: "flex",
            textTransform: "none",
          }}
        >
          <Typography sx={{ width: "90%", color: "white", fontWeight: "bold" }}>
            Buy now
          </Typography>
          <Box sx={{ width: "10%", display: "flex" }}>
            <Divider
              orientation='vertical'
              flexItem
              sx={{ bgcolor: "white" }}
            />
            <span>
              <ShoppingCartOutlinedIcon sx={{ color: "white", mx: 2 }} />
            </span>
          </Box>
        </Button>
      </Box>
    </Paper>
  );
};

export default ImageCard;
